// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__1G2jc","header":"Messages_header__gj3s1"};